import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Header from "../../common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb";
import {
  SUPER_ADMIN_BREADCRUMB,
  SUPER_ADMIN_BREADCRUMBS_PAGES,
} from "Constants/BreadcrumbConstant";
import ConfirmationModal from "../../common/Modal/ConfirmationModal";
import _ from "lodash";
import { apiGetRequest, apiPostRequest } from "../../../helpers/Requests";
import { toast } from "react-toastify";
import CircularLoader from "../../common/CircularLoader/CircularLoader";
import SideBar from "../../common/SideBar/SideBarNew";
import InputCreationForm from "../../common/InputCreationForm/InputCreationForm";
import SectionCreationForm from "../../common/SectionCreationForm/SectionCreationForm";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { LoginContext } from "../../../helpers/LoginContext";
import CustomButton from "../../common/Button/CustomButton";
import { parseBooleanVal } from "Utils/utils";
import { FormBuilderSectionList } from "../shared/FormBuilderComponents";
import { FormBuilderExperienceControls } from "../shared/FormBuilderExperienceModal";
import PdfFormImportButton, {
  resolvePdfImportEndpoint,
} from "../shared/PdfFormImportButton";
import SelectOption from "../../common/Select/Select";
import FormCategorySelect from "../shared/FormCategorySelect";
import apiCall from "store/services/sp.services";
import api from "store/services/sil.services";
import FormBuilderDiscardButton from "../shared/FormBuilderDiscardButton";
import SweetAlertConfirmationModal from "components/common/SweetAlertConfirmation/SweetAlertConfirmation";
import {
  createFormBuilderSnapshot,
  formBuilderSnapshotsEqual,
} from "../shared/formBuilderSnapshotUtils";
import FormScopeBadge from "../shared/FormScopeBadge";
import {
  extractFormCategoriesFromResponse,
  resolveFormScopeFromRole,
} from "../shared/formCategoryUtils";

const EditFormTemplate = ({ role }) => {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { state } = location;

  const routeRole = role === "sil" ? "sil" : role === "hrm" ? "sp/hrm" : "sp";

  const [routeroleAccess, setRouteroleAccess] = useState(null);

  useEffect(() => {
    if (routeroleAccess && routeroleAccess !== role) {
      window.location.reload();
    }
  }, [role]);

  const [showInputModal, setShowInputModal] = useState(false);
  const [showSectionModal, setShowSectionModal] = useState(false);
  const [showSubSectionModal, setShowSubSectionModal] = useState(false);
  const [showSubSectionInputModal, setShowSubSectionInputModal] =
    useState(false);
  const [showEditSectionModal, setShowEditSectionModal] = useState(false);
  const [showEditSectionTitle, setShowEditSectionTitle] = useState(false);
  const [showEditSubSectionModal, setShowEditSubSectionModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [
    showSectionTitleConfirmationModal,
    setShowSectionTitleConfirmationModal,
  ] = useState(false);
  const [showSubSectionConfirmationModal, setShowSubSectionConfirmationModal] =
    useState(false);
  const [sectionIndex, setSectionIndex] = useState(null);
  const [subSectionIndex, setSubSectionIndex] = useState(null);
  const [fieldIndex, setFieldIndex] = useState(null);
  const [subFieldIndex, setSubFieldIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [defaultFieldType, setDefaultFieldType] = useState(null);
  const [template, setTemplate] = useState([]);
  const [pdfImportReview, setPdfImportReview] = useState(null);
  const [templateFrom, setTemplateForm] = useState([]);
  const [formCategories, setFormCategories] = useState([]);
  const [formSubCategories, setFormSubCategories] = useState([]);
  const [selectedFormCategory, setSelectedFormCategory] = useState(null);
  const [selectedFormSubCategory, setSelectedFormSubCategory] = useState(null);
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
    saveRequested: false,
    saveSuccess: false,
    saveFailed: false,
  });
  const [baselineSnapshot, setBaselineSnapshot] = useState(null);
  const [showExitConfirmationModal, setShowExitConfirmationModal] = useState(false);
  const initialBaselineCommitted = useRef(false);

  useEffect(() => {
    setRouteroleAccess(role);
    fetchTemplate();
    fetchCategories();
  }, [location.pathname]);

  const resolveTemplateCategoryId = (templateData) => {
    if (!templateData) return null;
    return role === "sil"
      ? templateData?.form_category_with_name?.id ??
          templateData?.category_id ??
          templateData?.form_category_id
      : templateData?.form_category_id ??
          templateData?.form_category_with_name?.id ??
          templateData?.category_id;
  };

  const resolveFormCategoryOption = (templateData, categories) => {
    if (!templateData) return null;

    const categoryId = resolveTemplateCategoryId(templateData);
    if (categoryId == null) return null;

    const matched = categories.find(
      (item) => item.id == categoryId || item.value == categoryId
    );
    if (matched) return matched;

    const categoryName = templateData?.form_category_with_name?.name;
    if (categoryName) {
      return {
        id: categoryId,
        value: categoryId,
        label: categoryName,
        name: categoryName,
      };
    }

    return null;
  };

  useEffect(() => {
    const categoryId = resolveTemplateCategoryId(templateFrom);
    if (categoryId == null || formCategories.length === 0) {
      return;
    }

    const category = resolveFormCategoryOption(templateFrom, formCategories);

    if (category) {
      setSelectedFormCategory(category);
    }

    const subCategorySource =
      category?.form_sub_categories?.length > 0
        ? category.form_sub_categories
        : formCategories.find(
            (item) => item.id == categoryId || item.value == categoryId
          )?.form_sub_categories;

    if (subCategorySource?.length > 0) {
      const subCategories = subCategorySource.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setFormSubCategories(subCategories);
      if (templateFrom.form_sub_category_id) {
        setSelectedFormSubCategory(
          subCategories.find(
            (item) => item.value == templateFrom.form_sub_category_id
          ) || null
        );
      }
    } else {
      setFormSubCategories([]);
      setSelectedFormSubCategory(null);
    }
  }, [
    templateFrom?.uuid,
    templateFrom?.form_category_id,
    templateFrom?.category_id,
    templateFrom?.form_category_with_name,
    formCategories,
    role,
  ]);

  useEffect(() => {
    if (initialBaselineCommitted.current || request.isRequested) {
      return;
    }
    if (!templateFrom?.uuid || template.length === 0) {
      return;
    }
    if (
      role !== "sil" &&
      resolveTemplateCategoryId(templateFrom) != null &&
      !selectedFormCategory
    ) {
      return;
    }

    setBaselineSnapshot(
      createFormBuilderSnapshot({
        template,
        templateFrom,
        selectedFormCategory,
        selectedFormSubCategory,
      })
    );
    initialBaselineCommitted.current = true;
  }, [
    template,
    templateFrom,
    selectedFormCategory,
    selectedFormSubCategory,
    request.isRequested,
    role,
  ]);

  const currentSnapshot = useMemo(
    () =>
      createFormBuilderSnapshot({
        template,
        templateFrom,
        selectedFormCategory,
        selectedFormSubCategory,
      }),
    [template, templateFrom, selectedFormCategory, selectedFormSubCategory]
  );

  const hasUnsavedChanges = useMemo(
    () =>
      baselineSnapshot
        ? !formBuilderSnapshotsEqual(currentSnapshot, baselineSnapshot)
        : false,
    [baselineSnapshot, currentSnapshot]
  );

  const restoreBaselineSnapshot = () => {
    if (!baselineSnapshot) {
      return;
    }

    setTemplate(_.cloneDeep(baselineSnapshot.template));
    setTemplateForm(_.cloneDeep(baselineSnapshot.templateFrom));
    setSelectedFormCategory(baselineSnapshot.selectedFormCategory);
    setSelectedFormSubCategory(baselineSnapshot.selectedFormSubCategory);
    setSectionIndex(null);
    setFieldIndex(null);
    setSubFieldIndex(null);
  };

  const handleCancel = () => {
    if (hasUnsavedChanges) {
      setShowExitConfirmationModal(true);
      return;
    }
    navigate(-1);
  };

  const openInputModalHandler = (index) => {
    setDefaultFieldType(null);
    setShowInputModal(true);
    setSectionIndex(index);
  };

  const openLegacyAddFieldModal = (
    sectionIndex,
    fieldType = null,
    subSectionFieldIndex = null
  ) => {
    setSectionIndex(sectionIndex);
    setDefaultFieldType(fieldType);
    if (subSectionFieldIndex != null) {
      setFieldIndex(subSectionFieldIndex);
      setShowSubSectionInputModal(true);
      return;
    }
    setShowInputModal(true);
  };

  const closeInputModalHandler = () => {
    setShowInputModal(false);
    setDefaultFieldType(null);
  };

  const openSubSectionModalHandler = (index) => {
    setShowSubSectionModal(true);
    setSectionIndex(index);
  };

  const closeSubSectionModalHandler = () => {
    setShowSubSectionModal(false);
  };

  const openSubSectionInputModalHandler = (index, i) => {
    setDefaultFieldType(null);
    setShowSubSectionInputModal(true);
    setSectionIndex(index);
    setFieldIndex(i);
  };

  const closeSubSectionInputModalHandler = () => {
    setShowSubSectionInputModal(false);
    setDefaultFieldType(null);
  };

  const openSectionModalHandler = () => {
    setShowSectionModal(true);
  };

  const closeSectionModalHandler = () => {
    setShowSectionModal(false);
  };

  const openEditSectionModalHandler = (sectionIndex, fieldIndex, item) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    if (item.hasOwnProperty("required")) {
      item.required.toString();
    }
    setEditData(item);
    setShowEditSectionModal(true);
  };

  const closeEditSectionModalHandler = () => {
    setShowEditSectionModal(false);
  };

  const openEditSectionTitleModal = (
    sectionIndex,
    fieldIndex,
    item,
    subFieldIndex,
    type = "section"
  ) => {
    setSectionIndex(sectionIndex);
    setSubSectionIndex(fieldIndex);
    setEditData(item);
    setShowEditSectionTitle(true);
  };

  const closeSectionTitleHandler = () => {
    setShowEditSectionTitle(false);
  };

  const openEditSubSectionModalHandler = (
    sectionIndex,
    fieldIndex,
    item,
    subFieldIndex
  ) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    if (item.hasOwnProperty("required")) {
      item.required.toString();
    }
    setEditData(item);
    setShowEditSubSectionModal(true);
  };

  const closeEditSubSectionModalHandler = () => {
    setShowEditSubSectionModal(false);
  };

  const openConfirmationModalHandler = (
    sectionIndex,
    fieldIndex,
    subFieldIndex,
    type
  ) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    setShowConfirmationModal(true);
  };

  const closeConfirmationModalHandler = () => {
    setShowConfirmationModal(false);
  };

  const openSectionTitleConfirmationModalHandler = (sectionIndex) => {
    setSectionIndex(sectionIndex);
    setShowSectionTitleConfirmationModal(true);
  };

  const closeSectionTitleConfirmationModalHandler = () => {
    setShowSectionTitleConfirmationModal(false);
  };

  const openSubSectionConfirmationModalHandler = (
    sectionIndex,
    fieldIndex,
    subFieldIndex
  ) => {
    //console.log(sectionIndex,fieldIndex,subFieldIndex);
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    setShowSubSectionConfirmationModal(true);
  };

  const closeSubSectionConfirmationModalHandler = () => {
    setShowSubSectionConfirmationModal(false);
  };

  const fetchCategories = async () => {
    try {
      const res =
        role === "sil"
          ? await api.silFormCategoriesApi()
          : await apiCall.formCategoriesRequest({ role });
      const data = extractFormCategoriesFromResponse(res).map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setFormCategories(data);
    } catch (err) {
      toast.error(err.message || "Unable to load form categories.");
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedFormCategory(category);
    setSelectedFormSubCategory(null);
    const categoryValue = category?.value ?? null;
    setTemplateForm({
      ...templateFrom,
      form_category_id: categoryValue,
      ...(role === "sil" ? { category_id: categoryValue } : {}),
      form_sub_category_id: null,
    });

    if (category?.form_sub_categories?.length > 0) {
      setFormSubCategories(
        category.form_sub_categories.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }))
      );
    } else {
      setFormSubCategories([]);
    }
  };

  const fetchTemplate = async () => {
    setRequest({ ...request, isRequested: true });

    try {
      const url =
        routeRole === "sil"
          ? `${routeRole}/form/template`
          : `${routeRole}/form_template`;

      let res = await apiGetRequest(
        `${url}${
          state && state.hasOwnProperty("templateObj")
            ? `?form_template_uuid=${state.templateObj.templateUUID}&form_template_slug=${state.templateObj.templateSlug}`
            : `?form_template_slug=${slug}`
        }`
      );
      if (res.status !== 200) {
        setRequest({ ...request, isRequested: false, isFailed: true });
      }
      if (res.status === 200 && res?.data && res?.data?.data) {
        const templateData = res.data.data;
        const normalizedCategoryId = resolveTemplateCategoryId(templateData);
        setTemplate(JSON.parse(templateData.template || "[]"));
        const resolvedCategoryId =
          normalizedCategoryId ?? templateData.form_category_id ?? null;
        setTemplateForm({
          ...templateData,
          form_category_id: resolvedCategoryId,
          ...(role === "sil" ? { category_id: resolvedCategoryId } : {}),
        });
      }
      setRequest({ ...request, isRequested: false, isSuccess: true });
    } catch (err) {
      console.log(err);
    }
  };

  const updateTemplate = async () => {
    if (isUserGracePeriodOver) {
      return;
    }
    const categoryId = resolveTemplateCategoryId(templateFrom);
    if (categoryId == null) {
      toast.error("Form category is required.");
      return;
    }
    const data = {
      ...templateFrom,
      form_category_id: templateFrom.form_category_id ?? categoryId,
      template: template,
    };
    if (role === "sil") {
      data.category_id = data.form_category_id ?? categoryId;
    }
    delete data.id;
    setRequest({ ...request, saveRequested: true });
    try {
      const url =
        role === "sil"
          ? `${routeRole}/form/update`
          : `${routeRole}/provider_form_template`;
      const res = await apiPostRequest(`${url}?id=${data.uuid}`, data);
      if (res.status === 201 || res.status === 200) {
        setRequest({ ...request, saveRequested: false, saveSuccess: true });
        toast.success("Template Updated Successfully!");
        setTimeout(
          () =>
            navigate(
              role === "sil"
                ? "/forms-accommodation"
                : routeRole === "sp/hrm"
                ? "/forms-list-hrm"
                : "/forms-list"
            ),
          800
        );
      } else {
        setRequest({ ...request, saveRequested: false, saveFailed: false });
        toast.error("Something Went Wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addInputFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields.push(data);
    setTemplate(list);
  };

  const updateFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex] = data;

    setTemplate(list);
  };

  const updateSubSectionFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex].sub_fields[subFieldIndex] =
      data;
    // console.log("list", list);
    setTemplate(list);
  };

  const deleteFieldHandler = () => {
    const list = _.cloneDeep(template);
    list[sectionIndex].input_fields.splice(fieldIndex, 1);
    setTemplate(list);
    setShowConfirmationModal(false);
  };

  const deleteSectionHandler = () => {
    const list = _.cloneDeep(template);
    list.splice(sectionIndex, 1);
    setTemplate(list);
    setShowSectionTitleConfirmationModal(false);
  };

  const deleteSubSectionFieldHandler = () => {
    const list = _.cloneDeep(template);
    if (typeof subFieldIndex === "number") {
      list[sectionIndex].input_fields[fieldIndex].sub_fields.splice(
        subFieldIndex,
        1
      );
    } else list[sectionIndex].input_fields.splice(fieldIndex, 1);
    setTemplate(list);
    setShowSubSectionConfirmationModal(false);
  };

  const addSectionHandler = (data) => {
    const list = _.cloneDeep(template);
    data.input_fields = [];
    list.push(data);
    setTemplate(list);
  };

  const editSectionTitleHandler = (data) => {
    const list = _.cloneDeep(template);
    if (data.type === "sub_section") {
      list[sectionIndex].input_fields[subSectionIndex].isAddOther =
        parseBooleanVal(data.isAddOther);
      list[sectionIndex].input_fields[subSectionIndex].section_title =
        data.section_title;
    } else {
      list[sectionIndex].section_title = data.section_title;
    }
    setTemplate(list);
    setShowEditSectionTitle(false);
  };

  const addSubSectionHandler = (data) => {
    data.type = "sub_section";
    data.lable = "";
    data.sub_fields = [];
    data.isAddOther = parseBooleanVal(data.isAddOther);
    const list = _.cloneDeep(template);
    list[sectionIndex].input_fields.push(data);
    setTemplate(list);
  };

  const addSubSectionInputFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex].sub_fields.push(data);
    setTemplate(list);
  };

  const breadcrumbPages = useMemo(() => {
    const pages = SUPER_ADMIN_BREADCRUMB(
      SUPER_ADMIN_BREADCRUMBS_PAGES.UPDATE_FORM_TEMPLATE,
      role
    );
    const currentTitle = templateFrom?.title || slug;

    if (pages.length > 0 && currentTitle) {
      pages[pages.length - 1] = {
        name: currentTitle,
        href: "#",
        state: null,
      };
    }

    return pages;
  }, [role, slug, templateFrom?.title]);

  return (
    <div className=''>
      <div className='min-h-screen'>
        <SideBar classes='bg-gradient' />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          }`}
        >
          {/* <HeaderAdmin /> */}
          {request.isRequested ? (
            <div className='flex justify-center items-center min-h-screen form-page'>
              <CircularLoader
                classes='flex justify-center items-center'
                classloader='loader-l'
              />
            </div>
          ) : (
            <div className='form-builder-page w-full mb-2 space-y-4 max-w-[1440px] sm:px-6 lg:px-8'>
              <Header
                title={templateFrom?.title || slug}
                titleBadge={
                  <FormScopeBadge scope={resolveFormScopeFromRole(role)} />
                }
                breadcrumb={<Breadcrumb pages={breadcrumbPages} />}
              />
              <div className='form-builder-meta-card'>
                <div className='form-builder-meta-toolbar'>
                  <p className='form-builder-meta-card-header'>Form details</p>
                  <div className='form-builder-actions form-builder-actions--inline'>
                    <PdfFormImportButton
                      endpoint={resolvePdfImportEndpoint({ routeRole })}
                      hasExistingFields={template.some(
                        (section) => (section.input_fields || []).length > 0
                      )}
                      onImported={(draft) => {
                        setTemplate(draft.template);
                        setPdfImportReview({
                          documentKind: draft.document_kind,
                          reviewRequired: Boolean(draft.review_required),
                          warnings: draft.warnings || [],
                        });
                        if (draft.title) {
                          setTemplateForm((current) => ({
                            ...current,
                            title: draft.title,
                          }));
                        }
                      }}
                    />
                    <FormBuilderExperienceControls
                      template={template}
                      formTitle={templateFrom?.title}
                      formDescription={templateFrom?.description}
                    />
                    <FormBuilderDiscardButton
                      hasChanges={hasUnsavedChanges}
                      onDiscard={() => {
                        restoreBaselineSnapshot();
                        setPdfImportReview(null);
                      }}
                      isDisabled={request.isRequested || request.saveRequested}
                    />
                    <CustomButton
                      variant='danger'
                      cssClass='form-btn-cancel'
                      label='Cancel'
                      clickHandler={handleCancel}
                    />
                    <div>
                      <CustomButton
                        isDisabled={isUserGracePeriodOver}
                        showLoading={request.saveRequested}
                        label='Update'
                        clickHandler={updateTemplate}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                  <label htmlFor='edit-form-title' className='did-floating-label'>
                    Title
                  </label>
                  <input
                    id='edit-form-title'
                    value={templateFrom?.title ?? ""}
                    type='text'
                    className='did-floating-input'
                    onChange={(event) =>
                      setTemplateForm({ ...templateFrom, title: event.target.value })
                    }
                  />
                </div>
                {role !== "sil" && (
                  <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                    <label className='did-floating-label'>Form Category</label>
                    <FormCategorySelect
                      role={role}
                      categories={formCategories}
                      selectedOption={selectedFormCategory}
                      onCategoryCreated={(category) => {
                        setFormCategories((prev) => [...prev, category]);
                      }}
                      onChange={handleCategoryChange}
                    />
                  </div>
                )}
                {role === "sil" && (
                  <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                    <label className='did-floating-label'>Form Category</label>
                    <FormCategorySelect
                      role="sil"
                      categories={formCategories}
                      selectedOption={selectedFormCategory}
                      onCategoryCreated={(category) => {
                        setFormCategories((prev) => [...prev, category]);
                      }}
                      onChange={handleCategoryChange}
                    />
                  </div>
                )}
                {formSubCategories.length > 0 && (
                  <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                    <label className='did-floating-label'>
                      Form Sub Category
                    </label>
                    <SelectOption
                      isClearable={true}
                      isSearch={false}
                      data={formSubCategories}
                      selectedOption={selectedFormSubCategory}
                      handleChange={(subCategory) => {
                        setSelectedFormSubCategory(subCategory);
                        setTemplateForm({
                          ...templateFrom,
                          form_sub_category_id: subCategory ? subCategory.value : null,
                        });
                      }}
                    />
                  </div>
                )}
                <div className='col-span-12 form-builder-meta-field did-floating-label-content'>
                  <label htmlFor='edit-form-description' className='did-floating-label'>
                    Description
                  </label>
                  <textarea
                    id='edit-form-description'
                    value={templateFrom?.description ?? ""}
                    className='form-textarea form-builder-meta-textarea'
                    rows={2}
                    onChange={(event) =>
                      setTemplateForm({
                        ...templateFrom,
                        description: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <FormBuilderSectionList
                template={template}
                setTemplate={setTemplate}
                importReview={pdfImportReview}
                onDismissImportReview={() => setPdfImportReview(null)}
                openInputModalHandler={openInputModalHandler}
                openSubSectionModalHandler={openSubSectionModalHandler}
                openSubSectionInputModalHandler={openSubSectionInputModalHandler}
                openEditSectionTitleModal={openEditSectionTitleModal}
                openEditSectionModalHandler={openEditSectionModalHandler}
                openEditSubSectionModalHandler={openEditSubSectionModalHandler}
                openSectionTitleConfirmationModalHandler={
                  openSectionTitleConfirmationModalHandler
                }
                openSubSectionConfirmationModalHandler={
                  openSubSectionConfirmationModalHandler
                }
                openConfirmationModalHandler={openConfirmationModalHandler}
                openSectionModalHandler={openSectionModalHandler}
                onLegacyAddFieldRequest={openLegacyAddFieldModal}
              />
            </div>
          )}
        </div>
      </div>

      {showInputModal && (
        <InputCreationForm
          formCategoryId={templateFrom?.form_category_id}
          showModal={showInputModal}
          title='Add Section Input Field'
          dataSubmitHandler={addInputFieldHandler}
          closeModalHandler={closeInputModalHandler}
          template={template}
          sectionIndex={sectionIndex}
          subSectionIndex={fieldIndex}
          defaultFieldType={defaultFieldType}
        />
      )}
      {showSubSectionModal && (
        <SectionCreationForm
          title='Add New Sub Section'
          showModal={showSubSectionModal}
          type='sub_section'
          dataSubmitHandler={addSubSectionHandler}
          closeModalHandler={closeSubSectionModalHandler}
        />
      )}
      {showSubSectionInputModal && (
        <InputCreationForm
          formCategoryId={templateFrom?.form_category_id}
          title='Add Sub Section Input Field'
          showModal={showSubSectionInputModal}
          dataSubmitHandler={addSubSectionInputFieldHandler}
          closeModalHandler={closeSubSectionInputModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={fieldIndex}
          template={template}
          defaultFieldType={defaultFieldType}
        />
      )}
      {showSectionModal && (
        <SectionCreationForm
          title='Add New Section'
          showModal={showSectionModal}
          type='section'
          dataSubmitHandler={addSectionHandler}
          closeModalHandler={closeSectionModalHandler}
        />
      )}
      {showEditSectionTitle && (
        <SectionCreationForm
          title={
            editData && editData.type === "sub_section"
              ? "Edit sub Section Title"
              : "Edit Section Title"
          }
          showModal={showEditSectionTitle}
          type={
            editData && editData.type === "sub_section"
              ? "sub_section"
              : "section"
          }
          editData={editData}
          dataSubmitHandler={editSectionTitleHandler}
          closeModalHandler={closeSectionTitleHandler}
        />
      )}
      {showEditSectionModal && (
        <InputCreationForm
          formCategoryId={templateFrom?.form_category_id}
          title='Edit Section Input Field'
          showModal={showEditSectionModal}
          template={template}
          editData={editData}
          dataSubmitHandler={updateFieldHandler}
          closeModalHandler={closeEditSectionModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={fieldIndex}
        />
      )}
      {showEditSubSectionModal && (
        <InputCreationForm
          formCategoryId={templateFrom?.form_category_id}
          title='Edit Sub Section Input Field '
          showModal={showEditSubSectionModal}
          editData={editData}
          dataSubmitHandler={updateSubSectionFieldHandler}
          closeModalHandler={closeEditSubSectionModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={fieldIndex}
          template={template}
        />
      )}

      <ConfirmationModal
        showModal={showConfirmationModal}
        closeModalHandler={closeConfirmationModalHandler}
        submitHandler={deleteFieldHandler}
      />
      <ConfirmationModal
        showModal={showSectionTitleConfirmationModal}
        closeModalHandler={closeSectionTitleConfirmationModalHandler}
        submitHandler={deleteSectionHandler}
      />
      <ConfirmationModal
        showModal={showSubSectionConfirmationModal}
        closeModalHandler={closeSubSectionConfirmationModalHandler}
        submitHandler={deleteSubSectionFieldHandler}
      />
      {showExitConfirmationModal && (
        <SweetAlertConfirmationModal
          isOpen={showExitConfirmationModal}
          title='Leave without saving?'
          content='You have unsaved changes. Leave anyway, or stay and use Discard changes to restore the last saved version.'
          setIsConfirm={(confirmed) => {
            setShowExitConfirmationModal(false);
            if (confirmed) {
              navigate(-1);
            }
          }}
        />
      )}
    </div>
  );
};

export default EditFormTemplate;
